import {
  MoiaViewBox,
  NoDataState,
  PictureConstructionSite,
} from '@backoffice-frontend/patterns'
import { Card } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

export const PageNotFoundView = () => {
  const { t } = useTranslation()
  return (
    <MoiaViewBox>
      <Card
        css={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 112px)',
        }}
      >
        <NoDataState
          title={t('common_notFoundPage_title')}
          description={t('common_notFoundPage_description')}
          picture={<PictureConstructionSite />}
        />
        <Link to="/">
          {t('authenticatedAppView_pageNotFound_returnToHomepage')}
        </Link>
      </Card>
    </MoiaViewBox>
  )
}
